import PageHero from '../../components/PageHero';
import { Link } from 'react-router-dom';
import './StaticPage.css';

function PrivacyPolicyPage() {
  return (
    <div className="static-page content-page">
      <PageHero
        title="Privacy Policy"
        subtitle="How we collect, use, and protect your information"
      />
      <div className="content-container">
        <p className="last-updated">Last updated: March 2025</p>
        <p>
          WeddingzVenue (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) is committed to protecting your privacy.
          This policy explains how we collect, use, disclose, and safeguard your information when you use our
          website and services.
        </p>

        <h2>Information we collect</h2>
        <p>We may collect information that you provide directly, including:</p>
        <ul>
          <li>Name, email address, phone number, and mailing address</li>
          <li>Account credentials when you register or log in</li>
          <li>Enquiry and booking details (venue/vendor preferences, dates, budget)</li>
          <li>Business information when you list your venue or vendor profile</li>
          <li>Communications with our support team</li>
        </ul>

        <h2>How we use your information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide, maintain, and improve our services</li>
          <li>Process enquiries and connect you with venues and vendors</li>
          <li>Send you updates, offers, and marketing (with your consent)</li>
          <li>Respond to your requests and support needs</li>
          <li>Analyse usage and trends to improve user experience</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h2>Sharing of information</h2>
        <p>
          We may share your information with venues and vendors when you send an enquiry, and with service
          providers who assist our operations (e.g. hosting, analytics). We do not sell your personal
          information to third parties.
        </p>

        <h2>Data security</h2>
        <p>
          We implement appropriate technical and organisational measures to protect your personal data
          against unauthorised access, alteration, disclosure, or destruction.
        </p>

        <h2>Your rights</h2>
        <p>
          Depending on your location, you may have the right to access, correct, delete, or port your
          personal data, or to object to or restrict certain processing. Contact us at{' '}
          <a href="mailto:contact@weddingzvenue.in">contact@weddingzvenue.in</a> to exercise these rights.
        </p>

        <h2>Contact us</h2>
        <p>
          For questions about this Privacy Policy, please contact us at{' '}
          <a href="mailto:contact@weddingzvenue.in">contact@weddingzvenue.in</a> or visit our{' '}
          <Link to="/contact">Contact</Link> page.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
